module.exports =  {
    apiUrl: {        // 本地环境接口地址
        dev: 'http://127.0.0.1:8081/scmp',
        // dev:'http://192.168.1.106:8081/scmp',
        // 生产环境接口地址
        pro: 'http://49.232.212.90:7006/cdfy',
        // pro: 'http://47.109.143.105:10025/cdfy',
        // 本地环境socket地址
        socket_dev: 'ws://192.168.1.104:8080/cdfy/webSocket/',
        // 生产环境socket地址
        socket_pro: 'ws://49.232.212.90:7006/cdfy/webSocket/'
        // socket_pro: 'ws://http://47.109.143.105:10025/cdfy/'
    },
    signature: {
        clientId: '5fe1690ba1ba0d010be18f38',
        clientKey: '51a4ad8f-b310-4781-b10b-dc597126b9a0'
    },
    // pubshAdd: 'bj',
    pubshAdd: 'tj',
    basic: 'NWZlMTY5MGJhMWJhMGQwMTBiZTE4ZjM4OjVmZGFmNDRhMzFkYzFhMDZkZjQ2M2ZmYw==',
    /*
		全局地图中心点:
			清华园：116.330987,40.006829
	*/
    centerPoint: '117.804833,39.165618'
};
